import { render } from "./CircleBadge.vue?vue&type=template&id=52195812"
import script from "./CircleBadge.vue?vue&type=script&lang=ts"
export * from "./CircleBadge.vue?vue&type=script&lang=ts"
script.render = render

export default script